import { UIText2, Image, UIText3 } from '@cian/ui-kit';
import { IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { UndergroundIcon } from '../../../containers/AddressContainer/underground_icon';
import { IUnderground } from '../../../types/offer';

type TUserCardOffer = {
  locationId?: number;
  fullUrl: string;
  formattedFullInfo: string;
  address: string;
  underground?: IUnderground;
  previewImage: string;
};

export const UserCardOffer: React.FC<TUserCardOffer> = ({
  locationId,
  fullUrl,
  formattedFullInfo,
  address,
  underground,
  previewImage,
}) => {
  return (
    <div className={styles['container']} data-testid="UserCardOffer">
      <a className={styles['offer']} href={fullUrl} target="_blank" rel="noreferrer">
        <div className={styles['content']}>
          <div className={styles['image']}>
            {previewImage ? (
              <Image
                src={previewImage}
                alt="Фотография объявления"
                borderRadius={'4px'}
                objectFit="cover"
                theme="light"
                height={40}
                width={40}
                preloader
                data-testid="UserCardOfferImage"
              />
            ) : (
              <div className={styles['empty']} data-testid="UserCardOfferEmptyImage">
                <IconPlaceholderImages24 color="current_color" />
              </div>
            )}
          </div>
          <div className={styles['address']}>
            <span className={styles['address_text']}>
              <UIText3>
                {underground && locationId && (
                  <span data-testid={'UserCardOfferUnderground'}>
                    <UndergroundIcon width={12} height={12} color={`#${underground.lineColor}`} regionId={locationId} />
                    &nbsp;
                    {underground.name},&nbsp;
                  </span>
                )}
                {address}
              </UIText3>
            </span>
            <UIText2>{formattedFullInfo}</UIText2>
          </div>
        </div>
      </a>
    </div>
  );
};
